import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AiFeatureCardComponent } from './ai-feature-card.component';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { MotionBackgroundComponent } from '../shared/motion-background.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ai-section',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    AiFeatureCardComponent,
    ScrollAnimationDirective,
    MotionBackgroundComponent
  ],
  template: `
    <section class="ai-section">
      <app-motion-background></app-motion-background>
      <div class="container">
        <div class="content" scrollAnimation>
          <h2>{{ 'AISECTION.TITLE' | translate }}</h2>
          <p class="subtitle">{{ 'AISECTION.SUBTITLE' | translate }}</p>
          
          <div class="features-grid">
            <app-ai-feature-card
              *ngFor="let feature of aiFeatures"
              [feature]="feature">
            </app-ai-feature-card>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .ai-section {
      position: relative;
      background: #6a1b9a;
      color: white;
      overflow: hidden;
      padding: 3rem 0;
    }

    .content {
      position: relative;
      z-index: 1;
    }

    h2 {
      font-size: 3rem;
      text-align: center;
      margin-bottom: 1rem;
      color: white;
    }

    .subtitle {
      text-align: center;
      font-size: 1.25rem;
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: 4rem;
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
      margin-bottom: 4rem;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
    }

    @media (max-width: 1024px) {
      .features-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (max-width: 768px) {
      .features-grid {
        grid-template-columns: 1fr;
        max-width: 400px;
      }
    }
  `]
})
export class AiSectionComponent implements OnInit {
  aiFeatures: Array<{ icon: string; title: string; description: string }>;

  constructor(public _translate: TranslateService) {}

  ngOnInit(): void {
    this.aiFeatures = [
      {
        icon: 'insights',
        title: this._translate.instant('AISECTION.FEATURES.REAL_TIME_ANALYSIS.TITLE'),
        description: this._translate.instant('AISECTION.FEATURES.REAL_TIME_ANALYSIS.DESCRIPTION')
      },
      {
        icon: 'dashboard',
        title: this._translate.instant('AISECTION.FEATURES.AI_POWERED_DASHBOARDS.TITLE'),
        description: this._translate.instant('AISECTION.FEATURES.AI_POWERED_DASHBOARDS.DESCRIPTION')
      },
      {
        icon: 'trending_up',
        title: this._translate.instant('AISECTION.FEATURES.SMART_GROWTH_TOOLS.TITLE'),
        description: this._translate.instant('AISECTION.FEATURES.SMART_GROWTH_TOOLS.DESCRIPTION')
      }
    ];
  }
}
